export const createUserDocumentationUrl = 'https://snty.link/create-docs?ref=studio'
